import { useState, useEffect, useCallback } from 'react';
import { fetchRules } from './api';
import PublicRules from './components/PublicRules';

export default function PublicRulesApp() {
	const [rules, setRules] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const load = useCallback(async () => {
		setLoading(true);
		setError(null);
		try {
			setRules(await fetchRules(false));
		} catch (err) {
			setError(err.message || 'Laden fehlgeschlagen.');
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		load();
	}, [load]);

	return (
		<PublicRules
			rules={rules}
			loading={loading}
			error={error}
			onRetry={load}
		/>
	);
}